package com.anjuros.website.templates.template4.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.ChevronLeftIcon
import com.anjuros.website.components.shared.ChevronRightIcon
import com.anjuros.website.templates.template4.modules.Template4Project
import com.anjuros.website.templates.template4.modules.Template4Theme
import com.anjuros.website.templates.template4.modules.getColor
import com.anjuros.website.templates.template4.util.Template4Constants
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template4GalleryDescription(template4Project: Template4Project,
                                animatedOpacity:Float,
                                onLeftProjectArrowClicked:(template4Project: Template4Project)->Unit,
                                onRightProjectArrowClicked:(template4Project: Template4Project)->Unit){

    Box(modifier = Modifier.fillMaxWidth(80.percent)){

        Column(
            modifier = Modifier.fillMaxWidth().align(Alignment.Center),
            verticalArrangement = Arrangement.SpaceBetween,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Row(modifier = Modifier.margin(bottom = 10.px)
                .opacity(animatedOpacity)
                .transition(Transition.of("opacity", 1800.ms)),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically) {
                ChevronLeftIcon(modifier = Modifier.color(Colors.Black)
                    .cursor(Cursor.Pointer)
                    .onClick { onLeftProjectArrowClicked(template4Project) },
                    size = 30)
                P(
                    attrs = Modifier
                        .margin(leftRight = 15.px)

                        .fontFamily(Template4Constants.FONT_FAMILY)
                        .fontSize(32.px)
                        .fontWeight(FontWeight.Bold)
                        .color(Template4Theme.Primary.getColor())
                        .toAttrs()
                ) {
                    Text(LocalText(template4Project.projectName))

                }
                ChevronRightIcon(modifier = Modifier.color(Colors.Black).cursor(Cursor.Pointer)
                    .onClick { onRightProjectArrowClicked(template4Project) },
                    size = 30)

            }
            P(
                attrs = Modifier
                    .fontFamily(Template4Constants.FONT_FAMILY)
                    .opacity(animatedOpacity)
                    .transition(Transition.of("opacity",2500.ms, delay = 400.ms))
                    .fontSize(18.px)
                    .fontWeight(FontWeight.Normal)
                    .fontStyle(FontStyle.Italic)
                    .color(Template4Theme.Secondary.rgb)
                    .toAttrs()
            ) {
                Text(LocalText(template4Project.description))

            }
        }


    }
}